import { z } from 'zod';

import { createOffsetPaginationRequestQuerySchema } from './pagination';
import { SourceSchema } from './sources';
import { commaDelimitedList } from './utils';

/**
 * A collection is a construct to represent a dataset that we sell and make available to our customers
 */
export const CollectionSchema = z.object({
  collectionId: z.string().nanoid(),
  name: z.string(),
  description: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type Collection = z.infer<typeof CollectionSchema>;

export const CollectionsSchema = z.array(CollectionSchema);

export type Collections = z.infer<typeof CollectionsSchema>;

export const CollectionsQuerySchema = createOffsetPaginationRequestQuerySchema(
  z.enum(['createdAt', 'updatedAt', 'name']),
).merge(
  z.object({
    collectionIds: commaDelimitedList(
      CollectionSchema.shape.collectionId.array(),
    ).optional(),
    sourceIds: commaDelimitedList(
      SourceSchema.shape.sourceId.array(),
    ).optional(),
  }),
);

export type CollectionsQuery = z.infer<typeof CollectionsQuerySchema>;

export const CollectionSearchQuerySchema = z.object({
  query: z.string(),
  limit: z.coerce.number().default(100).optional(),
});

export type CollectionSearchQuery = z.infer<typeof CollectionSearchQuerySchema>;

export const CollectionSearchResultSchema = z.object({
  collectionId: z.string(),
  score: z.number(),
});

export type CollectionSearchResult = z.infer<
  typeof CollectionSearchResultSchema
>;
